import React, { useState, useEffect } from 'react';
import { Building2, Search, CheckCircle2 } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { getCustomerCompanies } from '../../../../../services/staffingService';

const Step1Customer = ({ providerCompanyId, selectedCustomer, onSelect }) => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [search, setSearch]       = useState('');

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const resp = await getCustomerCompanies(providerCompanyId);
        setCustomers(resp.data.customerCompanies || resp.data.customers || []);
      } catch {}
      finally { setLoading(false); }
    })();
  }, [providerCompanyId]);

  const filtered = customers.filter((c) => {
    const q = search.toLowerCase();
    return (
      c.companyFriendlyName?.toLowerCase().includes(q) ||
      c.companyLegalName?.toLowerCase().includes(q)
    );
  });

  return (
    <div>
      <p className="mb-4 text-sm text-muted-foreground">
        Select the customer this job will be assigned to.
      </p>

      {/* Search */}
      <div className="relative mb-4">
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search customers…"
          className="w-full rounded-lg border border-border bg-background pl-9 pr-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-brand-pink/30"
        />
      </div>

      {loading ? (
        <div className="space-y-2">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="h-14 animate-pulse rounded-xl bg-muted" />
          ))}
        </div>
      ) : filtered.length === 0 ? (
        <p className="text-sm text-muted-foreground">No customers found.</p>
      ) : (
        <div className="max-h-80 overflow-y-auto space-y-1.5 pr-1">
          {filtered.map((c) => {
            const isSelected = selectedCustomer?._id === c._id;
            return (
              <motion.button
                key={c._id}
                whileHover={{ scale: 1.005 }}
                onClick={() => onSelect(c)}
                className={`w-full flex items-center gap-3 rounded-xl border p-3 text-left transition-colors ${
                  isSelected
                    ? 'border-brand-pink bg-brand-pink/5'
                    : 'border-border bg-card hover:bg-muted/30'
                }`}
              >
                <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl bg-primary/10">
                  <Building2 size={15} className="text-primary" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className={`truncate text-sm font-semibold ${isSelected ? 'text-brand-pink' : 'text-card-foreground'}`}>
                    {c.companyFriendlyName || c.companyLegalName}
                  </p>
                  {c.companyLegalName && c.companyFriendlyName && (
                    <p className="truncate text-xs text-muted-foreground">{c.companyLegalName}</p>
                  )}
                </div>
                {isSelected && <CheckCircle2 size={16} className="flex-shrink-0 text-brand-pink" />}
              </motion.button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Step1Customer;
